export default {
    'name': 'long-arrow',
    'width': '40',
    'height': '40',
    'viewBox': '0 0 40 40',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M19.329 1.25851C19.3528 1.23696 19.3774 1.21677 19.4027 1.19792L19.329 1.25851ZM19.3276 1.25978L10.329 9.40238C9.91952 9.77294 9.88794 10.4053 10.2585 10.8148C10.6291 11.2244 11.2614 11.2559 11.671 10.8854L19 4.2535L19 39C19 39.5523 19.4477 40 20 40C20.5523 40 21 39.5523 21 39L21 4.25351L28.329 10.8854C28.7385 11.2559 29.3709 11.2244 29.7415 10.8148C30.112 10.4053 30.0805 9.77294 29.671 9.40238L20.6745 1.26169C20.4966 1.09915 20.2599 1 20 1C19.7898 0.999998 19.5796 1.06597 19.4027 1.19792\' fill=\'#FF4171\'/>'
}
